import styled from 'styled-components';

export default styled.h1`
  font-family: 'UniversCondensed', sans-serif;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
`;
